export default {
  init() {
    // JavaScript to be fired on all pages

    (function( $ ) {
        'use strict';

        // MOBILE MENU
        $('.menutoggle').click(function(){
            $('.header-main').toggleClass('open');
        });

        // MENU FOLDOUTS
        $( ".menu-item-has-children" ).append( "<span class='foldout-toggle'></span>" );
        $( "nav" ).on('click', '.menu-item-has-children .foldout-toggle', function(e){
            e.preventDefault();
            $(this).parent().toggleClass('open');
        });
        $( ".menu-item-has-children.active" ).each(function(){
            $(this).toggleClass('open');
        });

        /**
         * Init slick slider
         */
        $('.slick-slider').slick({
            dots : true,
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
        });

        /**
         * Init faq collapser
         */
        $('.faq__question').on('click', function(){
           $(this).next().slideToggle(150, function(){
               $(this).parent().toggleClass('faq__item--open');
           });
        });

        /**
         * Init tabs
         */
        $('.tabs').each(function(){

            $(this).find('.tabs__tab').on('click focus', function() {

                var tabgroup = $(this).parent().parent();

                tabgroup.find('.tabs__sheet--active').removeClass('tabs__sheet--active');
                tabgroup.find('.tabs__tab--active').removeClass('tabs__tab--active');

                $(this).addClass('tabs__tab--active');
                tabgroup.find('.tabs__sheet:nth-child('+ ($(this).index() + 1) +')').addClass('tabs__sheet--active');

            });

        });

    })( jQuery );

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js